// import 'react-app-polyfill/stable'
// import 'core-js'
// import React from 'react'
// import ReactDOM from 'react-dom'
// import App from './App'
// import * as serviceWorker from './serviceWorker'
// import { Provider } from 'react-redux'
// import store from './store'

// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root'),
// )

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister()
import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./store";
import reactDom from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { LoadingProvider } from "./context/LoadingContext";

const rootElement = document.getElementById("root");

const root = reactDom.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <Router>
      <LoadingProvider>
        <App />
      </LoadingProvider>
    </Router>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
